module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "edit-event"
  }, [_c('div', {
    staticClass: "centered back link"
  }, [_c('span', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v("← К списку мероприятий")])]), _vm._v(" "), (_vm.eventObject) ? _c('div', {
    staticClass: "event"
  }, [_c('div', {
    staticClass: "event-header-wrapper",
    style: (_vm.photoContainerStyle)
  }, [(_vm.eventObject.photo || this.base64photo) ? _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": _vm.handleDeleteEventPhoto
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "event-header translucent-wrapper"
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок",
      "required": ""
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.eventObject.title),
      callback: function($$v) {
        _vm.$set(_vm.eventObject, "title", $$v)
      },
      expression: "eventObject.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Назавние мероприятия",
      "required": ""
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.eventObject.description),
      callback: function($$v) {
        _vm.$set(_vm.eventObject, "description", $$v)
      },
      expression: "eventObject.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [(!_vm.eventObject.photo) ? _c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadPhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить фото\n            ")]) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns event-description is-multiline"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('b-field', {
    staticClass: "start-date",
    attrs: {
      "label": "Дата мероприятия"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "editable": false,
      "placeholder": "Выберите дату и время"
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('b-field', {
    staticClass: "end-date",
    attrs: {
      "label": "Дата окончания регистрации"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "editable": false,
      "placeholder": "Выберите дату и время"
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.registrationEndDate),
      callback: function($$v) {
        _vm.registrationEndDate = $$v
      },
      expression: "registrationEndDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('b-field', {
    attrs: {
      "label": "Адрес проведения (без города)"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Введите адрес"
    },
    on: {
      "change": _vm.handleUpdateAddress
    },
    model: {
      value: (_vm.eventObject.address),
      callback: function($$v) {
        _vm.$set(_vm.eventObject, "address", $$v)
      },
      expression: "eventObject.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('b-field', {
    attrs: {
      "label": "Кому подходит"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Опишите кому полезно мероприятие"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.eventObject.toWhom),
      callback: function($$v) {
        _vm.$set(_vm.eventObject, "toWhom", $$v)
      },
      expression: "eventObject.toWhom"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('b-field', {
    attrs: {
      "label": "Email ответственного за мероприятие (через запятую)"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Введите email",
      "required": ""
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.eventObject.email),
      callback: function($$v) {
        _vm.$set(_vm.eventObject, "email", $$v)
      },
      expression: "eventObject.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('b-field', {
    attrs: {
      "label": "Ссылка"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Ссылка"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.eventObject.link),
      callback: function($$v) {
        _vm.$set(_vm.eventObject, "link", $$v)
      },
      expression: "eventObject.link"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.center) ? _c('div', {
    staticClass: "map-container"
  }, [_c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Укажите адрес на карте")]), _vm._v(" "), _c('gmap-map', {
    staticStyle: {
      "height": "350px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 15,
      "options": {
        scrollwheel: false
      }
    },
    on: {
      "click": _vm.selectAddress
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('div', {
    staticClass: "button delete-pin",
    on: {
      "click": _vm.deletePin
    }
  }, [_vm._v("Удалить метку")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "talks"
  }, [_c('b-field', {
    attrs: {
      "label": "Обсудим"
    }
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": "new-information",
      "placeholder": "Напишите, что узнают посетители"
    },
    model: {
      value: (_vm.newInformation),
      callback: function($$v) {
        _vm.newInformation = $$v
      },
      expression: "newInformation"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Чем полезно для меня?"
    }
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": "reason",
      "placeholder": ""
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('b-field', {
    attrs: {
      "label": "Партнеры (верхний блок)"
    }
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Выберите партнеров",
      "multiple": true,
      "trackBy": "id",
      "custom-label": _vm.customLabel,
      "selectLabel": "",
      "deselectLabel": "",
      "options": _vm.partners
    },
    model: {
      value: (_vm.eventObject.topPartners),
      callback: function($$v) {
        _vm.$set(_vm.eventObject, "topPartners", $$v)
      },
      expression: "eventObject.topPartners"
    }
  })], 1), _vm._v(" "), _c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.eventObject.topPartnersTitle),
      callback: function($$v) {
        _vm.$set(_vm.eventObject, "topPartnersTitle", $$v)
      },
      expression: "eventObject.topPartnersTitle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('b-field', {
    attrs: {
      "label": "Партнеры (нижний блок)"
    }
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Выберите партнеров",
      "multiple": true,
      "trackBy": "id",
      "custom-label": _vm.customLabel,
      "selectLabel": "",
      "deselectLabel": "",
      "options": _vm.partners
    },
    model: {
      value: (_vm.eventObject.bottomPartners),
      callback: function($$v) {
        _vm.$set(_vm.eventObject, "bottomPartners", $$v)
      },
      expression: "eventObject.bottomPartners"
    }
  })], 1), _vm._v(" "), _c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.eventObject.bottomPartnersTitle),
      callback: function($$v) {
        _vm.$set(_vm.eventObject, "bottomPartnersTitle", $$v)
      },
      expression: "eventObject.bottomPartnersTitle"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Услуги"
    }
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Выберите услуги",
      "multiple": true,
      "trackBy": "id",
      "custom-label": _vm.customLabel,
      "selectLabel": "",
      "deselectLabel": "",
      "options": _vm.availableServices
    },
    model: {
      value: (_vm.eventObject.services),
      callback: function($$v) {
        _vm.$set(_vm.eventObject, "services", $$v)
      },
      expression: "eventObject.services"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "event-items"
  }, _vm._l((_vm.eventObject.eventItems), function(item) {
    return _c('EventItem', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddEventItem
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить пункт программы\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "add-summary"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.toggleSummary
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить фотоотчет с описанием\n          ")])]), _vm._v(" "), (_vm.eventObject.showSummary) ? _c('div', {
    staticClass: "summary-content has-text-centered"
  }, [_c('span', {
    staticClass: "link",
    on: {
      "click": _vm.handleLoadSummaryPhoto
    }
  }, [_vm._v("Загрузить фото")]), _vm._v(" "), _c('input', {
    ref: "loadSummaryPhotoButton",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.loadSummaryPhotoHandler
    }
  }), _vm._v(" "), (_vm.eventObject.photos.length) ? _c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.eventObject.photos), function(photo) {
    return _c('swiper-slide', {
      key: photo
    }, [_c('div', {
      staticClass: "centered"
    }, [(typeof photo === 'string') ? _c('img', {
      attrs: {
        "src": "/upload/photos/" + photo
      }
    }) : _c('img', {
      attrs: {
        "src": photo.base64photo
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "button is-danger delete-summary-photo",
      on: {
        "click": function($event) {
          return _vm.deleteSummaryPhoto(photo)
        }
      }
    }, [_vm._v("\n                  Удалить\n                ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2) : _vm._e(), _vm._v(" "), _c('b-field', {
    staticClass: "summary-text",
    attrs: {
      "label": "Краткий обзор мероприятия"
    }
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "id": "summary",
      "placeholder": "Введите текст"
    },
    model: {
      value: (_vm.summary),
      callback: function($$v) {
        _vm.summary = $$v
      },
      expression: "summary"
    }
  })], 1)], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.eventObject) ? _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveEvent()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])]) : _vm._e()]), _vm._v(" "), (_vm.eventObject) ? _c('div', {
    staticClass: "columns"
  }, [(!_vm.event.isNew) ? _c('div', {
    staticClass: "column delete-service centered is-one-third",
    on: {
      "click": function($event) {
        return _vm.deleteEvent(_vm.event)
      }
    }
  }, [_vm._v("\n      Удалить\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column hide"
  }, [_c('b-switch', {
    model: {
      value: (_vm.eventObject.publishLater),
      callback: function($$v) {
        _vm.$set(_vm.eventObject, "publishLater", $$v)
      },
      expression: "eventObject.publishLater"
    }
  }, [_vm._v("Опубликовать позже")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "editable": false,
      "placeholder": "Дата публикации на сайте"
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.publishDate),
      callback: function($$v) {
        _vm.publishDate = $$v
      },
      expression: "publishDate"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c645db48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/EditEvent.vue
// module id = 999
// module chunks = 0